import React from "react";
import CustomHeading from "../custom/CustomHeading";
import CustomContent from "../custom/CustomContent";
import leaderImg from "../../assets/sudhaImg.jpg";
import mobileLeaderImg from "../../assets/mobileLeader.jpg";
import PreLoadingImages from "../custom/PreLoadingImages";

const FirstSection = () => {
  return (
    <div className="flex flex-col  bg-[#FFF3ED] gap-3 py-[3%] px-[4%]">
      <PreLoadingImages images={[leaderImg, mobileLeaderImg]} />
      <CustomHeading
        text={"Positive Parenting"}
        textSize={"70px"}
        textColor={"#D31C4F"}
        showHeart={true}
        heartPosition={"absolute"}
        textAlign={"center"}
        heartMarginLeft={window.innerWidth < 450 ? "10px" : "26px"}
        heartTop={window.innerWidth < 450 ? "0px" : "0px"}
        margin="mt-[15px]"
      />
      <CustomContent
        text={
          "Parenting is not just about raising children, it's about raising parents too."
        }
        textAlign="center"
      />
      <div className="flex lg:flex-row sm:mt-[50px] mt-[10px] justify-center items-center flex-col gap-[1rem] sm:gap-[4rem]">
         <img
          src={window.innerWidth < 450 ? mobileLeaderImg : leaderImg}
          alt="leaderImg"
          loading="eager"
          className="lg:w-[500px] w-[380px] h-[260px] object-cover sm:h-[460px] rounded-xl"
        />
        <CustomContent
          text={
            " Positive Parenting is a belief, a way of living. It is something which acts as a base for your tiny tot. Mrs. Sudha Gupta, the Honorary chairperson of Mother's Pride and Presidium schools, strongly believes in the subject of positive parenting and promotes it by spreading awareness about the same. Mrs. Gupta conducts regular parenting seminars, which inspire parents to understand their child better. Her immense knowledge on parenting is shared in the form of weekly parenting tips. Thousands of parents are benefitting from these words of wisdom, which help them to inculcate the right qualities in their kids to help them become the leaders of tomorrow."
          }
          textAlign={window.innerWidth < 450 ? "left" : "justify"}
          textSize={"24px"}
          width={"50%"}
          leading={window.innerWidth < 450 ? "24px" : "36px"}
        />
      </div>
    </div>
  );
};

export default FirstSection;
